export default {
  apiKey: "AIzaSyCEVHbhjbaXeh-PQu6E31BbTSmy7zw5OQg",
  authDomain: "pravo-na-jizn.firebaseapp.com",
  projectId: "pravo-na-jizn",
  storageBucket: "pravo-na-jizn.appspot.com",
  messagingSenderId: "6176883321",
  appId: "1:6176883321:web:96bc1eb9869f011899caa8",
  measurementId: "G-FPJ30ZVGHP"
}